export const ENV = import.meta.env.VITE_ENV;
export const API_BASE_URL =
    (["local"].includes(ENV) ? "http://" : "https://") +
    import.meta.env.VITE_API_BASE_URL;
export const SOCKET_BASE_URL =
    (["local"].includes(ENV) ? "ws://" : "wss://") +
    import.meta.env.VITE_API_BASE_URL;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const FORECAST_BASE_URL = "https://forecastapp.com/1327211";
export const FLOAT_BASE_URL = "https://makers.float.com";
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL;
export const STRIPE_API_KEY = import.meta.env.VITE_STRIPE_API_KEY;
export const DEFAULT_LLM_MODEL = import.meta.env.VITE_DEFAULT_LLM_MODEL;
export const APP_VERSION =
    typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : null;
